import _pickBy from 'lodash/pickBy';

export const queryDataSanitizer = filters => {
  const { queryType, contract, identification, identificationType } = filters;

  const sanitizedFilters = {
    searchType: queryType,
    contractId: queryType === 'contract' ? contract.toString() : null,
    identification: queryType === 'id' ? identification.toString() : null,
    typeOfIdentification: queryType === 'id' ? identificationType : null
  };

  return _pickBy(sanitizedFilters, filter => !!filter);
};

export const queryDataNoHolderSanitizer = filters => {
  const { contract, identification, identificationType } = filters;

  const sanitizedFilters = {
    contractId: contract.toString(),
    identification: identification.toString(),
    typeOfIdentification: identificationType,
  };

  return _pickBy(sanitizedFilters, filter => !!filter);
};